import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Icon } from '../../../../components';

const ValidationIcon = ({
  message
}) => message ? (
  <div className='has-error'>
    <OverlayTrigger trigger='click' placement='right' overlay={
      <Popover id='validation-icon'>
        <div className='has-error'>
          <span>
            {message}
          </span>
        </div>
      </Popover>
    }>
      <Icon icon='info' iconSize={3} />
    </OverlayTrigger>
  </div>
) : null

export default ValidationIcon


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/validation-icon.js